import { ADMIN_CLICKED, ADMIN_TOGGLED } from './actionTypes';
import { inviteeAuthorized } from './invitee';


export const toggleAdminPanel = () => ({
  type: ADMIN_CLICKED,
});

export const toggleAdminMode = () => ({
  type: ADMIN_TOGGLED,
});

// Action Creators

export function adminClicked() {
  return dispatch => {
    dispatch(toggleAdminPanel());
  };
}

export function toggleAdmin() {
  return dispatch => {
    dispatch(inviteeAuthorized());
    dispatch(toggleAdminMode());
  };
}


// WEBPACK FOOTER //
// ./src/actions/admin.js